<script setup>
import { ref } from 'vue';
import OrderSummary from '@/modules/Signup/components/sign-up-form/OrderSummary.vue';
import { VInput, VRadioButton } from '@/modules/Signup/components';
import VButtonGroup from '@/modules/Signup/components/VButtonGroup.vue';
import { useSignUpModuleStore } from '@/stores/modules/signup/signUpStore';
import { storeToRefs } from 'pinia/dist/pinia';

const
    signUpStore = useSignUpModuleStore(),
    { avcDto } = storeToRefs(signUpStore);

const optNtd = ref([
    { label: 'Yes, I have NTD', value: true },
    { label: 'No, I need NTD', value: false },
]);
</script>

<template>
    <div class="tw-flex tw-items-start tw-gap-x-20">
        <div class="tw-w-3/5">
            <div class="tw-flex tw-flex-col tw-gap-24">
                <div class="tw-flex tw-flex-col tw-gap-8">
                    <h4 class="!tw-font-bold">Help us connect to your NBN service faster</h4>
                    <p class="tw-leading-tight">We’ll need your ‘Access Virtual Circuit Identifier’ (also known as AVC
                        ID) from your current
                        provider.</p>

                    <p>Before you begin:</p>
                    <ul class="!tw-list-disc !tw-ml-12">
                        <li>Ensure you are the account holder for the active nbn service.</li>
                        <li>Find the <strong>15-character AVC ID</strong> on your latest invoice from your current
                            provider.
                        </li>
                        <li>Enter your AVC ID below to help is get your service up and running faster.</li>
                    </ul>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-8">
                    <VInput
                        v-model="avcDto.avcId"
                        label="Your AVC ID"
                        label-class="!tw-text-[20px]"
                    >
                        <template #description>
                            <p class="tw-leading-tight !tw-mt-6">
                                If you don’t provide your AVC ID, the service switch may take up to 2 business days.
                            </p>
                        </template>
                    </VInput>

                    <!--
                        TODO:
                            - create a slot for tooltip, i.e., when that slot is present, the (i) will be visible
                            beside the label
                    -->
                    <VRadioButton
                        :options="[
                            {
                                // TODO: dummy, it should be put somewhere, probably in store
                                id: 1,
                                name: 'I want to proceed without the AVC ID. I understand that I will be responsible for' +
                                 'cancelling my current connection.'
                            },
                        ]"
                        label="What’s an AVC ID?"
                        label-class="!tw-text-[20px] tw-underline"
                        list-item-class="!tw-text-[20px]"
                    />
                </div>

                <div>
                    <h4 class="!tw-font-semibold !tw-mb-10">Do you have a Network Termination Device (NTD) at your
                        property?</h4>
                    <p class="tw-leading-tight !tw-mb-8">
                        In order for nbn to be activated at your property at NTD must be installed (at no additional
                        cost).
                    </p>

                    <VButtonGroup
                        v-model="avcDto.ntdId"
                        label="What is NTD?"
                        label-class="tw-font-semibold tw-underline"
                        :options="optNtd"
                    />
                </div>
            </div>
        </div>

        <OrderSummary class="tw-w-2/5" />
    </div>
</template>
